'use strict';
import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('FaqFormCtrl', ['$scope', '$http', '$attrs', '$log', function ($scope, $http, $attrs, $log) {
	$scope.form;
	$scope.submitted = false;
	$scope.name = '';
	$scope.email = '';
	$scope.question = '';
	
	$scope.formSubmit = function (e) {
		e.preventDefault();
		$scope.submitted = true;
		let is_grecaptcha = $scope.form.find('#g-recaptcha-response-hidden').length > 0;
		if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
			grecaptcha.ready(function () {
				grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action: 'submit'}).then(function (token) {
					if (document.getElementById('g-recaptcha-response-hidden')) {
						$('#g-recaptcha-response-hidden').val(token);
					} else {
						var inp = document.createElement('input');
						inp.type = 'hidden';
						inp.name = 'g-recaptcha-response';
						inp.value = token;
						$scope.form[0].appendChild(inp);
					}
					$scope.form[0].submit();
				});
			});
		} else {
			$scope.form[0].submit();
		}
	};
	
	$scope.formInvalid = function () {
		
		if ($scope.name == '') {
			return true;
		}
		
		if ($scope.email == '') {
			return true;
		}
		
		if ($scope.question == '') {
			return true;
		}
		
		if ($scope.submitted) {
			return true;
		}
	};

}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});